import { db } from "../firebaseConfig";
import { collection, getDocs, orderBy, query, doc, getDoc } from "firebase/firestore";

export default {
  name: "BugReportListLogic",
  data() {
    return {
      tickets: [],
      loading: false,
      error: null
    };
  },
  async created() {
    await this.fetchTickets();
  },
  methods: {
    async fetchTickets() {
      this.loading = true;
      try {
        const ticketsRef = collection(db, "devTickets");
        // Sort tickets by timestamp descending (newest first)
        const q = query(ticketsRef, orderBy("timestamp", "desc"));
        const snapshot = await getDocs(q);
        // Use Promise.all to fetch the full name for each ticket's addedBy field
        const ticketList = await Promise.all(
          snapshot.docs.map(async (docSnap) => {
            const data = docSnap.data();
            let fullName = data.addedBy; // fallback to user ID
            if (data.addedBy) {
              const userRef = doc(db, "users", data.addedBy);
              const userSnap = await getDoc(userRef);
              if (userSnap.exists()) {
                const userData = userSnap.data();
                fullName = userData.fullName || `${userData.firstName} ${userData.surname}`;
              }
            }
            return {
              id: docSnap.id,
              ...data,
              addedBy: fullName
            };
          })
        );
        this.tickets = ticketList;
      } catch (err) {
        console.error("Error fetching tickets:", err);
        this.error = "Error fetching tickets.";
      } finally {
        this.loading = false;
      }
    }
  }
};
